import React, { useCallback, useMemo, useState } from 'react';
import StickerAlbum from './StickerAlbum';
import { AlbumDashboardContext } from '../album/AlbumDashboardContext';

/**
 * Variante experimental: en /album2 el "Album Dashboard" no es una página
 * separada; vive como un panel derecho con dos modos.
 *
 *   - compacto (default): chips de conteo y últimos trades. El album mantiene
 *     country-cards-5.
 *   - expandido (view='dashboard'): panel absorbe ~2 columnas de países y
 *     muestra el dashboard completo. El album cae a country-cards-3.
 *   - expandido (view='collectors'): panel absorbe 1 columna de países y
 *     muestra la lista completa de coleccionistas. El album cae a 4 cols.
 *
 * El estado se expone por context y RightPanel + StickerAlbum lo consumen.
 */
function StickerAlbum2({ albumVariant }) {
  const [expanded, setExpanded] = useState(false);
  const [expandedView, setExpandedView] = useState('dashboard');

  const openExpandedView = useCallback((view) => {
    setExpandedView(view);
    setExpanded(true);
  }, []);

  const ctxValue = useMemo(() => ({
    expanded,
    expandedView,
    setExpanded,
    openExpandedView,
  }), [expanded, expandedView, openExpandedView]);

  return (
    <AlbumDashboardContext.Provider value={ctxValue}>
      <StickerAlbum albumVariant={albumVariant} />
    </AlbumDashboardContext.Provider>
  );
}

export default StickerAlbum2;
